module.exports = __webpack_public_path__ + "static/too-big-to-fail-265e713ca53e60d22b70794970bc42b3.jpg";